<template>
  <BaseSection>
    <template #header>
      <div class="section__layout">
        <BaseTitle
          tag="h1"
          size="xl"
          is-medium
          data-animation="fadeIn"
          data-animation-delay="100"
          v-html="'Во время прохождения<br> курса вы узнаете:'"
        />
      </div>
    </template>
    <template #content>
      <div class="section__layout">
        <BaseSteps :items="steps" :delay="300" is-double />
      </div>
    </template>
  </BaseSection>
</template>

<script>
import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseSteps from '@/components/BaseSteps.vue';

export default {
  name: 'AboutPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseTitle,
    BaseSteps,
  },
  staticData: () => ({
    steps: [
      {
        text: 'Как развивалось отношение к&nbsp;HR&#8209;бренду в&nbsp;России на протяжении 120&nbsp;лет и&nbsp;какие выводы из этого следуют',
        attrs: { size: 'xs' },
      },
      {
        text: 'Как коронакризис упростил понимание EVP и&nbsp;приблизил компании к&nbsp;трем ведущим решениям',
        attrs: { size: 'xs' },
      },
      {
        text: 'Какие практики применяют топовые работодатели в&nbsp;рамках заботы о&nbsp;сотрудниках',
        attrs: { size: 'xs' },
      },
    ],
  }),
};
</script>
